export { default as TechnicalIssues } from './page'


// WEBPACK FOOTER //
// ./src/pages/technicalIssues/index.js